<ion-app>
  <ion-router-outlet></ion-router-outlet>
</ion-app>
<div class="app-version">v{{appVersion}}</div>
